import { DeconstructedURL } from '@sonar-software/sonar-ts-lib';
import { useCurrentOrganization } from './useCurrentOrganization';
const defaultData = {
    instanceUrl: '',
    isSandbox: false
};
export function useCurrentOrganizationSubdomain() {
    var _a;
    const { instanceUrl, isSandbox } = (_a = useCurrentOrganization()) !== null && _a !== void 0 ? _a : defaultData;
    if (!instanceUrl) {
        return '';
    }
    const deconstructed = new DeconstructedURL(instanceUrl);
    return isSandbox ? `${deconstructed.subdomain}.sandbox` : deconstructed.subdomain;
}
